import PackageEditPageTemplate from '~/components/packages/PackageEditPageTemplate';
import { PackageTypes, PackageTypeWords } from '~/lib/PackageHelpers';

const SubscriptionEditPage = ({ initialTab }) => {
    return (
        <PackageEditPageTemplate
            singular={PackageTypeWords[PackageTypes.SUBSCRIPTION].singular}
            plural={PackageTypeWords[PackageTypes.SUBSCRIPTION].plural}
            basePath="/subscriptions"
            type={PackageTypes.SUBSCRIPTION}
            initialTab={initialTab}
        />
    );
};

export default SubscriptionEditPage;
